import React from "react";
import Container from "react-bootstrap/Container";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import Dropdown from "react-bootstrap/Dropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRightFromBracket } from "@fortawesome/free-solid-svg-icons";

function PortalLayout() {
  const { logout, userDetail } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/portal/login");
  };

  return (
    <Container className="dashboard-container px-0" fluid>
      {/* Sidebar on the Left */}
      <aside className="sidebar text-center">
        {/* Dynamic Logo */}
        <img
          src={`${process.env.PUBLIC_URL}/logo.png`}
          alt="Logo"
          className="admin-logo mb-3 mt-2"
        />

        <nav className="menu">
          <NavLink
            to="/portal/dashboard"
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            <img
              src={`${process.env.PUBLIC_URL}/Home.svg`}
              alt=""
              className="px-2"
            />
            Dashboard
          </NavLink>
          <hr />
          <NavLink
            to="/portal/change-password"
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            <img
              src={`${process.env.PUBLIC_URL}/Pie-Chart.svg`}
              alt=""
              className="px-2"
            />
            Change Password
          </NavLink>
          <hr />
        </nav>
      </aside>

      {/* Main Content on the Right */}
      <main className="main-content">
        <div className="top-bar">
          <div className="dropdown float-end">
            <Dropdown>
              <Dropdown.Toggle id="dropdown-basic">
                {userDetail?.name?.replace(/\b\w/g, (char) =>
                  char.toUpperCase()
                ) || "Applicant"}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={handleLogout}>
                  <FontAwesomeIcon
                    className="px-2"
                    icon={faArrowRightFromBracket}
                  />
                  Logout
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>

        {/* Render child pages here */}
        <Outlet />
      </main>
    </Container>
  );
}

export default PortalLayout;
